export const environment = {
  app_id: 'NM_DM_001',
  production: true,
  debug: false,
  debugauth: false,
  // Backend Server of Catalog Cloud
  // api_server: 'http://localhost:3300/api/v1',
  // base_url: 'http://localhost:3300/api/v1',
  // base_socket: 'http://localhost:3300/',

  // Backend Server of Auth Server
  auth_server: 'https://backguard.nousmedis.com/api/v1/',
  mode: 'prod',
  pop_duration: 10,
  base_protocol: 'http',
  base_domain: 'demo.catalogcloud.es',
  base_port: '3000',
  app_cookie_name: 'DEMO_NM_CC_001',
  role_cookie_name: 'DEMO_NM_CC_001_ROLE',
  user_current_org_cookie: 'DEMO_NM_CC_001_USER_CURRENT_ORG',
  user_orgs_cookie: 'DEMO_NM_CC_001_USER_ORGS',
  allow_change_cells: true
};